<template>
  <div>
    <div class="type-selection">
      <div
        class="type-selection__economy"
        v-bind:class="{ active: displayType === 'economy' }"
        @click="changeDisplayType('economy')"
      >
        {{ noAccount ? 'Economy' : getNameByType('economy') }}
      </div>
      <div
        class="type-selection__region"
        v-bind:class="{ active: displayType === 'region' }"
        @click="changeDisplayType('region')"
      >
        {{ noAccount ? 'Region' : getNameByType('region') }}
      </div>
    </div>
    <ComparisonCard :comparedWith="displayType"></ComparisonCard>
  </div>
</template>

<script>
import mixin from '../../utils/mixin';
import ComparisonCard from './ComparisonCard';

export default {
  mixins: [mixin],
  components: {
    ComparisonCard
  }
};
</script>

<style lang="scss" scoped>
.type-selection {
  display: flex;

  &__economy,
  &__region {
    margin: 1.5rem;
    margin-top: 0;
    padding-bottom: 5px;
    cursor: pointer;
  }

  &__economy {
    margin-left: 0;
  }

  .active {
    border-bottom: 2px solid $apnic-blue;
  }
}
</style>
